function googleAnalyticsEvent(category, action, label) {
  try {
    // eslint-disable-next-line no-undef
    ga('gtm2.send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
    });
  } catch {
    //pass
  }
}

export default googleAnalyticsEvent;
